import React, { useState } from 'react'
import {
  ChartCardWrapper,
  ChartCardHeader,
  ChartCardTitle,
  ChartCardControls,
  PeriodToggle,
  PeriodButton,
  ChartLegend,
  LegendItem,
  LegendDot,
} from '../HrAnalytics.styled'

interface LegendEntry {
  label: string
  color: string
  dashed?: boolean
}

interface IChartCard {
  title: string
  periods?: string[]
  activePeriod?: string
  onPeriodChange?: (period: string) => void
  legend?: LegendEntry[]
  rightControls?: React.ReactNode
  children: React.ReactNode
}

export const ChartCard = ({
  title,
  periods,
  activePeriod: controlledPeriod,
  onPeriodChange,
  legend,
  rightControls,
  children,
}: IChartCard) => {
  const [internalPeriod, setInternalPeriod] = useState(periods?.[0] || '')
  const activePeriod = controlledPeriod ?? internalPeriod

  const handlePeriodClick = (period: string) => {
    if (onPeriodChange) {
      onPeriodChange(period)
    } else {
      setInternalPeriod(period)
    }
  }

  return (
    <ChartCardWrapper>
      <ChartCardHeader>
        <ChartCardTitle>{title}</ChartCardTitle>
        <ChartCardControls>
          {periods && periods.length > 0 && (
            <PeriodToggle>
              {periods.map((p) => (
                <PeriodButton
                  key={p}
                  active={activePeriod === p}
                  onClick={() => handlePeriodClick(p)}
                >
                  {p}
                </PeriodButton>
              ))}
            </PeriodToggle>
          )}
          {legend && (
            <ChartLegend>
              {legend.map((entry) => (
                <LegendItem key={entry.label}>
                  <LegendDot color={entry.color} dashed={entry.dashed} />
                  {entry.label}
                </LegendItem>
              ))}
            </ChartLegend>
          )}
          {rightControls}
        </ChartCardControls>
      </ChartCardHeader>
      {children}
    </ChartCardWrapper>
  )
}
